import type {ErrorScreenProps} from '../ErrorBoundary'

export function getErrorScreenProps(): ErrorScreenProps {
  return {
    buttonProps: {
      view: 'action',
    },
  }
}
